import React, { forwardRef } from 'react';

import { testAttribute } from 'utils/DataTestId';
import { LocaleLink } from '../ContentLink/LocaleLink';
import { createLinkTracker, workaroundRef } from './Util';
import { useContentEntriesContext } from 'components/ContentEntriesProvider/ContentEntriesContext';
import { isInternalPath } from 'utils/IsInternalPath';

export const TrackedLink = forwardRef<
  HTMLAnchorElement,
  React.AllHTMLAttributes<HTMLAnchorElement> & { 'data-testid'?: string }
>(({ href, title, onClick, ...props }, ref) => {
  const { items } = useContentEntriesContext();
  const dataTestId = title ? testAttribute(title) : 'contact-policy';
  const to = href ?? '';

  if (to.indexOf('~') === 0 || isInternalPath(to, items)) {
    return (
      <LocaleLink
        innerRef={node => workaroundRef(node, ref)}
        to={to.replace('~', '')}
        data-testid={dataTestId}
        {...{ title, onClick, ...props }}
      />
    );
  }

  return <a ref={ref} onClick={createLinkTracker(onClick)} {...{ href, title, ...props }} />;
});
